<div class="space-y-3">
  <h3 class="font-bold">Fichar salida</h3>
  <p class="text-sm">Duración de la jornada: {{ calculateTimeDifference() }}</p>
  <p-button size="small" (onClick)="handleFichaje()" [loading]="isUploading" label="Confirmar salida"></p-button>
</div>
